
 

 

 

 
class UserUpdateRequest 
{
    
        Code: string;
    
        Login: string;
    
        Password: string;
    
        Name: string;
    
        Email: string;
    
        IsActive: boolean;
    
        IsGroup: boolean;
    
        UserUID: string;
    
        PasswordExpireDate: Date;
    
        AuthType: any;
    
        ExternalUserId: string;
    
        IsRequirePassword: boolean;
    
}
 
export default UserUpdateRequest;
 




